import React, {createRef, useEffect, useState} from 'react';
import {map, throttle, filter, get} from 'lodash';
import classNames from 'classnames';
import MindsetsJsSDK from "mindsets-js-sdk";

import AStream from './AStream';

// const fetchChallengesThrottle = function (callback) {
//     return throttle(callback, 2000, {
//         leading: false,
//         trailing: true
//     })
// }
// let channel_names = [];

export default function () {
    const header = createRef();

    const [streamType, setStreamType] = useState('challenge');
    const [streams, setStreams] = useState([]);

    function fetchStreams() {
        MindsetsJsSDK().API.get('streams/my', {}).then((response) => {
            setStreams(response.streams);
        }).catch((error) => {
            console.error(error);
        });
    }

    useEffect(() => {
        fetchStreams();
    }, []);

    // function subscribe() {
    //     challenge_versions.map(challenge_version => {
    //         challenge_version.lessons.map((l) => {
    //             const channel_name = `challenge_${challenge_version.challenge_code.code}_user_${l.user_id}_lessons`;
    //             const existing_channels = pusher.channels.all().map(channel => channel.name);
    //             if (existing_channels.indexOf(channel_name) < 0 || !pusher.channel(channel_name).subscribed) {
    //                 channel_names.push(channel_name);
    //                 pusher.subscribe(channel_name).bind('lessons.updated', () => {
    //                     fetchChallengesThrottle(fetchChallenges)();
    //                 });
    //             }
    //         });
    //     });
    // }

    // useEffect(() => {
    //     fetchChallengesThrottle(fetchChallenges)();
    // }, []);

    // useEffect(() => {
    //     if (Array.isArray(challenge_versions)) {
    //         subscribe();
    //     }
    // }, [challenge_versions]);

    // useEffect(() => {
    //     return () => {
    //         channel_names.map(channel_name => {
    //             const channel = pusher.channel(channel_name);
    //             if (channel && channel.subscribed) {
    //                 channel.unsubscribe();
    //                 channel.unbind_all();
    //             }
    //         });
    //         channel_names = [];
    //     }
    // }, []);

    function renderHeader() {
        const class_names_challenge = classNames('s-d-m-s-header', {
            's-d-m-s-header-active': streamType === 'challenge',
            's-d-m-s-header-inactive': streamType !== 'challenge'
        });
        const class_names_quiz = classNames('s-d-m-s-header', {
            's-d-m-s-header-active': streamType === 'quiz',
            's-d-m-s-header-inactive': streamType !== 'quiz'
        });
        const onClick = (new_stream_type) => (e) => {
            e.preventDefault();
            if (streamType !== new_stream_type) {
                setStreamType(new_stream_type);
            }
            return false;
        }
        return (
            <div className="flex-row flex-gap-20">
                <a className={class_names_challenge} onClick={onClick('challenge')}>
                    <h3 className="header-new" ref={header}>
                        {`My Challenges`}
                    </h3>
                </a>

                <div className="s-d-m-s-header-divider"></div>

                <a className={class_names_quiz} onClick={onClick('quiz')}>
                    <h3 className="header-new" ref={header}>
                        {`My Quizzes`}
                    </h3>
                </a>
            </div>
        );
    }

    function renderEmptyState() {
        return (
            <div>
                {`The Challenges (or Quizzes) shared or assigned to you by your teachers will appear here.`}
            </div>
        )
    }

    function renderFilling() {
        const n = Math.ceil(streams.length / 12) * 12
        const array_to_fill = Array(n - streams.length)
        return map(array_to_fill, (v, k) => {
            return (
                <div className="student-dashboard-a-stream-filling" key={`filling-${k}`}></div>
            )
        })
    }

    function renderStreams() {
        if (!streams) {
            return null;
        }

        const streams_to_render = filter(streams, (stream) => {
            const is_pq = get(stream, 'lesson.challenge_version.challenge_code.is_pq');
            switch (streamType) {
                case 'quiz':
                    return is_pq;
                case 'challenge':
                default:
                    return !is_pq;
            }
        });

        if (streams_to_render.length <= 0) {
            return renderEmptyState();
        }

        const render_streams = streams_to_render.map((stream, key) => {
            return (
                <div key={stream.id}>
                    <AStream
                        stream={stream}
                    />
                </div>
            )
        })

        return (
            <div className="flex-row-m flex-wrap flex-between flex-box-10-10">
                {render_streams}

                {renderFilling()}
            </div>
        )
    }

    return (
        <div className="student-dashboard-my-streams">
            {renderHeader()}

            <div className="section">
                {renderStreams()}
            </div>
        </div>
    );
}